import { render, staticRenderFns } from "./BaseCustomDrawer.vue?vue&type=template&id=366ec608&scoped=true&"
import script from "./BaseCustomDrawer.vue?vue&type=script&lang=js&"
export * from "./BaseCustomDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BaseCustomDrawer.vue?vue&type=style&index=0&id=366ec608&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366ec608",
  null
  
)

export default component.exports